import { VueQueryPlugin } from '@tanstack/vue-query'
import { createApp } from 'vue'
import VueGoogleMaps from 'vue-google-maps-community-fork'

import hyphen from '@/directives/hyphen.ts'
import { usePluginAnalytics } from '@/plugins/analytics.ts'
import { usePluginLuxon } from '@/plugins/luxon.ts'

// eslint-disable-next-line no-restricted-imports
import { useFirestore, usePluginFirestore } from './plugins/firebase.ts'
import { usePluginPersistence } from './plugins/persistence.ts'
import { usePluginTheme } from './plugins/theme.ts'
// eslint-disable-next-line no-restricted-imports
import { routerInstance } from './services/routing/router-instance.ts'
// eslint-disable-next-line no-restricted-imports
import { i18nInstance } from './services/translation/i18n-instance.ts'
import type { SignedInUser } from './services/use-user.ts'
import { useUser } from './services/use-user.ts'
import App from './App.vue'

const app = createApp(App)

app.use(VueQueryPlugin, {
  queryClientConfig: {
    defaultOptions: {
      queries: {
        gcTime: 1000 * 60 * 60 * 24, // staleTime: 1000 * 10,
      },
    },
  },
})

app.use(i18nInstance)

usePluginFirestore()
const firestore = useFirestore()
usePluginPersistence(firestore)

app.use(routerInstance)

function getUser(): SignedInUser | null {
  return useUser().user.value
}

usePluginTheme()
usePluginAnalytics(app, routerInstance, getUser)

usePluginLuxon()

app.use(VueGoogleMaps, { load: { key: import.meta.env.VITE_GOOGLE_MAPS_KEY } })

app.directive('hyphen', hyphen)

app.mount('#app')
